import { render } from "./SignInModal.vue?vue&type=template&id=2a971bcc"
import script from "./SignInModal.vue?vue&type=script&lang=js"
export * from "./SignInModal.vue?vue&type=script&lang=js"

import "./SignInModal.vue?vue&type=style&index=0&id=2a971bcc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__